.demo {
	display: flex;
	flex-direction: column;
	gap: var(--spacing-5);
	max-inline-size: 32rem;

	/* The field grows; fields carry shared/ui TextField styling now. */
	.signIn {
		display: flex;
		gap: var(--spacing-2);
		align-items: flex-end;

		> :first-child {
			flex: 1;
		}
	}
}

.who {
	display: flex;
	gap: var(--spacing-3);
	align-items: center;
}
